import {gql} from '@apollo/client';

export const BlogPagesQuery = gql`
  query BlogPages($cursor: String, $first: Int, $filter: BlogPageFilterInput) {
    blogPages(after: $cursor, first: $first, filter: $filter) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          slug
          title
          created
          banner(size: "420x227") {
            url
          }
        }
      }
    }
  }
`;

export const BlogPageQuery = gql`
  query BlogPage($id: ID, $slug: String) {
    blogPage(id: $id, slug: $slug) {
      seoTitle
      seoDescription
      seoImage {
        url
      }
      id
      slug
      title
      content
      created
      isPublished
      images {
        url
      }
      banner(size: "1232x666") {
        url
      }
    }
  }
`;
